import { colors } from '../../colors';
var header = {
  primaryColor: colors.black,
  hoverColor: colors.dirtyBlue,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.black,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.black,
  navUtilityLinkHoverColor: colors.black,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '18px'
};
export default header;